<!--促销文章和活动列表-->
<template>
  <div class="dlrActivity">
    <div class="dlrActivity-box">
      <div class="dlrActivity-head">
        <div class="dlrActivity-head-con">店内活动</div>
      </div>
      <div class="dlrActivity-scroll" ref="actContainer">
        <div class="dlrActivity-con">
          <template v-if="currentPromotion">
            <DetailHead
              :data-newsid="currentPromotion.NewsId"
              :imageSrc="currentPromotion.imageSrc"
              :title="currentPromotion.Title"
              :signStartTimeStr="currentPromotion.startTimeStr"
              :signEndTimeStr="currentPromotion.endTimeStr"
              :remainDays="currentPromotion.remainDays"
              :startTimeStr="currentPromotion.startTimeStr"
              :endTimeStr="currentPromotion.endTimeStr"
              :provinceName="provinceName"
            />
            <DetailContent
              :content="currentPromotion.Content"
              :imageArray="currentPromotion.imageArray"
            />
          </template>
          <template v-if="currentActivity">
            <DetailHead
              :activityid="currentActivity.id"
              :imageSrc="currentActivity.coverUrl"
              :title="currentActivity.title"
              :signStartTimeStr="currentActivity.signingStartTime"
              :signEndTimeStr="currentActivity.signingEndTime"
              :remainDays="currentActivity.remainDays"
              :startTimeStr="currentActivity.activityStartTime"
              :endTimeStr="currentActivity.activityEndTime"
              :provinceName="provinceName"
            />
            <DetailContent :content="currentActivity.content" />
          </template>
          <div
            class="dlrActivity-item"
            v-if="activitys.length || promotions.length"
          >
            <h3 class="dlrActivity-item-tit"><span>更多活动</span></h3>
            <template v-if="activitys.length > 0">
              <ListItem
                v-for="(item, index) in activitys"
                :key="item.id"
                :style="index === 0 ? 'margin-top:0;' : ''"
                :data-type="0"
                :data-id="item.id"
                :title="item.title"
                :coverUrl="item.coverUrl"
                :endTimeStr="item.endTimeStr"
                :summary="item.summary"
                :remainDays="item.remainDays"
                @click.native="loadActivityInfo(item.id)"
              />
            </template>
            <template v-if="promotions.length > 0">
              <ListItem
                v-for="(item, index) in promotions"
                :key="item.newsid"
                :data-id="item.newsid"
                :style="
                  index === 0 && activitys.length === 0 ? 'margin-top:0;' : ''
                "
                :title="item.title"
                :coverUrl="item.imgUrl"
                :endTimeStr="item.startTimeStr"
                :summary="item.Summary"
                :remainDays="item.remainDays"
                @click.native="
                  loadPromotionInfo({ id: item.newsId, openDetail: true })
                "
              />
            </template>
          </div>
        </div>
      </div>
      <div class="dlrActivity-btn" v-if="currentPromotion || currentActivity">
        <a href="javascript:void(0);" @click="sign" id="pAndActivityApply">
          <h3>我要报名</h3>
        </a>
      </div>
    </div>
    <!--短信验证码 start-->
    <ImgValidCodeSMSNew />
    <!--短信验证码 end-->
    <Popup />
  </div>
</template>
<script>
import { ScrollSync } from '@/services/socketIO/scroll';
import store from '@/store';
import { mapGetters, mapActions, mapMutations } from 'vuex';
import DetailHead from '@/components/Promotion/DetailHead.vue';
import ImgValidCodeSMSNew from '@/components/Order/ImgValidCodeSMSNew';
import DetailContent from '@/components/Promotion/DetailContent';
import Popup from '@/components/Popup/Index';
import ListItem from '@/components/Promotion/ListItem';
import * as layerNames from '@/services/layerName';
import shareManager from '@/services/share.manager';
import layerManager from '@/services/layer.manager';

const PROMOTION = 'promotion';
const ACTIVITY = 'activity';
// 定义常量
const LOAD_ACTIVITY_INFO = 'news/loadActivityInfo'; // 商家促销活动
const LOAD_PROMOTION_INFO = 'news/loadPromotionInfo'; // 促销文章（车商汇）
export default {
  props: {
    isAutoOpen: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    DetailHead,
    DetailContent,
    ListItem,
    Popup,
    ImgValidCodeSMSNew,
  },
  data() {
    return {
      layerName: layerNames.PROMOTION_LIST,
      visible: true,
    };
  },
  computed: {
    ...mapGetters({
      baseInfo: 'baseInfo',
      activitys: 'activitys',
      promotions: 'promotions',
      functionData: 'functionData',
      dealerInfo: 'dealer/dealerInfo',
    }),
    ...mapGetters('news', {
      newsInfo: 'newsInfo',
    }),
    dealerId() {
      return this.baseInfo.dealerId;
    },
    currentActivity() {
      return this.newsInfo.currentActivity;
    },
    currentPromotion() {
      return this.newsInfo.currentPromotion;
    },
    provinceName() {
      return this.dealerInfo?.ProvinceName ?? '';
    },
  },
  created() {
    const dealerId = this.$route.params.dealerId;
    const source = 'dealerm';
    if (dealerId && source) {
      this.setBaseInfo({
        dealerId: dealerId,
        source: source,
      });
    }
    this.initInfo();
    this.getSpecListByDealerId(dealerId);
  },
  mounted() {
    this.$nextTick(() => {
      let el = this.$refs['actContainer'];
      new ScrollSync('vue_PromotionList', el);
    });
  },
  methods: {
    ...mapMutations({
      setBaseInfo: 'setBaseInfo',
    }),
    ...mapActions({
      getBaseInfo: 'getBaseInfo',
      getFunctionData: 'getFunctionData',
      getSpecListByDealerId: 'dealer/getSpecListByDealerId',
    }),
    getOrderConditions() {
      this.getBaseInfo().then(() => {
        this.getFunctionData().then(() => {
          this.loadPromotionActivityList();
          this.initShare();
        });
      });
    },
    initShare() {
      shareManager.init({
        baseInfo: this.baseInfo,
        shareInfo: this.functionData.shareInfo,
      });
      this.setShareData();
    },
    setShareData() {
      const { type } = this.newsInfo;
      const activityInfo =
        type === 0 ? this.currentPromotion : this.currentActivity;
      const shareActivityInfo = {
        title: type === 0 ? activityInfo?.Title : activityInfo?.title,
        activityId: type === 0 ? activityInfo?.NewsId : activityInfo?.id,
        activityType: type === 0 ? PROMOTION : ACTIVITY,
        pvareaid: this.$route.query.pvareaid,
        remainDays: type === 0 ? activityInfo?.remainDays : activityInfo?.remainDays,
      };
      shareManager.setActivityH5(shareActivityInfo);
    },
    // 根据不同的活动类型，请求不同接口
    initInfo() {
      const type = this.$route.query.activityType;
      const activityId = this.$route.query.activityId || 0;
      if (activityId) {
        const actionMap = {
          activity: LOAD_ACTIVITY_INFO,
          promotion: LOAD_PROMOTION_INFO,
        };
        const action = actionMap[type];
        if (type === ACTIVITY) {
          store.dispatch(action, activityId).then((res) => {
            if (res && res.remainDays <= 0) {
              layerManager.toast({ message: '报名已结束' }, 2000);
            }
            this.getOrderConditions()
          });
        } else if (type === PROMOTION) {
          store
            .dispatch(action, { id: activityId, openDetail: true })
            .then((res) => {
              if (res && res.remainDays <= 0) {
                layerManager.toast({ message: '报名已结束' }, 2000);
              }
              this.getOrderConditions()
            });
        }
      }
    },
    loadActivityInfo(actId) {
      store.dispatch(LOAD_ACTIVITY_INFO, actId);
    },
    loadPromotionInfo({ id, openDetail }) {
      store.dispatch(LOAD_PROMOTION_INFO, { id: id, openDetail });
    },
    loadPromotionActivityList: function () {
      this.bindPromotionAndActivityListTemp();
    },
    bindPromotionAndActivityListTemp: function () {
      if (Array.isArray(this.promotions)) {
        this.promotions.forEach((element) => {
          var img = element.imgUrl;
          if (!img) {
            img = element.focusImgUrl;
          }
          if (img) {
            img = img.replace('http://', 'https://');
          }
          element.img = img;
        });
      }
    },
    sign() {
      let self = this;
      let seriesId = 0;
      let specId = 0;
      let eidKey = 'znzt_dinglancuxiao_baoming_click';
      if (self.isAutoOpen) {
        eidKey = 'znzt_called_promotion_click';
      }
      if (self.newsInfo.type === 0) {
        const currentPromotion = self.newsInfo.currentPromotion;
        if (currentPromotion.remainDays <= 0) {
          layerManager.toast({ message: '报名已结束' }, 2000);
          return;
        }
        if (
          currentPromotion &&
          currentPromotion.Specs &&
          currentPromotion.Specs.length > 0
        ) {
          seriesId = currentPromotion.Specs[0].SeriesId;
          specId = currentPromotion.Specs[0].SpecId;
        }
        layerManager.price(seriesId, specId, eidKey, 3, 0 ,'fromH5Activity');
      } else if (self.newsInfo.type === 1) {
        const activity = self.newsInfo.currentActivity;
        if (activity.remainDays <= 0) {
          layerManager.toast({ message: '报名已结束' }, 2000);
          return;
        }
        const activityId = activity.id;
        layerManager.price(seriesId, 0, eidKey, 2, activityId,'fromH5Activity');
      }
    },
    goTop() {
      let self = this;
      if (self.$refs.actContainer) {
        if ('scrollTo' in document.body) {
          self.$refs.actContainer.scrollTo(0, 0);
        } else {
          self.$refs.actContainer.scrollTop = 0;
        }
      }
    },
  },
  watch: {
    newsInfo: {
      handler() {
        setTimeout(() => {
          this.goTop();
        }, 100);
      },
      deep: true,
    },
    currentActivity: {
      handler(val) {
        if (val) {
          this.setShareData();
        }
      },
      deep: true,
    },
    currentPromotion: {
      handler(val) {
        if (val) {
          this.setShareData();
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss">
%dlrHeadIcon {
  display: inline-block;
  width: ptrd(44);
  height: ptrd(88);
  background: no-repeat center;
  background-size: ptrd(44);
  vertical-align: top;
}
.dlrActivity {
  height: 100%;
  background: #fff;
  &-box {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  &-head {
    position: relative;
    height: ptrd(88);
    line-height: ptrd(88);
    color: #111e36;
    font-weight: bold;
    flex-shrink: 0;
    a {
      color: initial;
    }
    &-con {
      padding: 0 ptrd(192);
      text-align: center;
      @extend %ellipsis-basic;
      font-size: ptrd(34);
    }
    &-right {
      position: absolute;
      top: 0;
      bottom: 0;
      font-size: 0;
      right: ptrd(40px);
      text-align: right;
    }
    &-btn {
      display: inline-block;
      vertical-align: top;
      margin: 0 ptrd(16);
      font-size: ptrd(28);
      color: #111e36;
      text-align: center;
      flex-shrink: 0;
      &:first-child {
        margin-left: 0;
      }

      &:last-child {
        margin-right: 0;
      }
    }
    .iconClose {
      @extend %dlrHeadIcon;
      background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAABCBAMAAAAReh3bAAAAJ1BMVEUAAAASHjZmboAVIjdnboMSHjdnbYARHzcSHTVnboARHjYRHjZmbX83wfOTAAAAC3RSTlMAqqolJZ+flLaU2zpA6tgAAADsSURBVEjH3dUhjgIxFAbg7ibLZleBxnAAHBKLRHAEjsA9MFyFIOsIsodiMiEP8XVaz1Pzmr9fk85kXvq02vTWf/OhGvjJp9fTNl+riWW+RSLPk/WV8y20EZF4n74cEYlrvXFbdBK0U0T0ECxAiLIDhA0i5EGIi5AWkQCBAIEAgQCBEIEAgQBZjEQLyRAgECAD0axzN/HfOaWP7OJiJ2pWLql9Y+vyaCPfZUgEUifKMQVSJ+7xiqeIFV+hBAgECAQIBAgECAQIBAgECAQIhIiEiITIbCDaf/59EEyPSNw7E+ivHDtTLO0mJ+GH1RO5wr2RgvOt+wAAAABJRU5ErkJggg==);
    }
  }
  &-scroll {
    flex: 1;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
  }
  &-btn {
    padding: ptrd(16px) ptrd(30px);
    a {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: ptrd(88px);
      background: #0055ff;
      border-radius: ptrd(16px);
      color: #fff;
      h3 {
        font-size: ptrd(32px);
        line-height: 1.2;
      }
    }
  }
  &-con {
    background: #f8f9fc;
    height: 100%;
    color: #111e36;
  }
  &-item {
    background: #fff;
    padding: 0 ptrd(30px) ptrd(30px);
    & + .dlrActivity-item {
      margin-top: ptrd(10px);
    }
    &-tit {
      height: ptrd(120px);
      font-size: ptrd(48px);
      display: flex;
      align-items: center;
      font-weight: bold;
      span {
        display: block;
      }
    }
    &-con {
      img {
        width: 100%;
        border-radius: 4px;
        & + img {
          margin-top: ptrd(20px);
        }
      }
    }
    &-paragraph {
      padding-bottom: ptrd(16px);
      font-size: ptrd(28px);
      line-height: ptrd(40px);
    }
  }
  &-pic {
    position: relative;
    padding-bottom: 50%;
    overflow: hidden;
    @extend %athm-holdimg-white;

    img {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 100%;
      transform: translateY(-50%) translateX(-50%);
    }
  }
  &-name {
    padding: ptrd(26px) 0 ptrd(16px);
    line-height: ptrd(44px);
    font-size: ptrd(36px);
  }
  &-subname {
    color: #666d7f;
    font-size: ptrd(26px);
    padding-bottom: ptrd(24px);
    line-height: ptrd(36px);
  }
  &-date {
    color: #999;
    font-size: ptrd(24px);
    line-height: ptrd(28px);
    & + .dlrActivity-date {
      padding-top: ptrd(20px);
    }
    &-title {
      margin-bottom: ptrd(10px);
    }
    &-info {
      em {
        color: #111e36;
        font-size: ptrd(26px);
      }
    }
  }
  &-deadline {
    display: flex;
    justify-content: space-between;
    &-left {
      color: #999;
      font-size: ptrd(24px);
      line-height: ptrd(28px);
    }
    &-right {
      font-size: 0;
      i,
      em {
        display: inline-block;
        vertical-align: middle;
        font-size: ptrd(24px);
      }
    }
    &-timeicon {
      width: ptrd(26px);
      height: ptrd(26px);
      background: url(data:image/png;base64,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)
        no-repeat center center;
      background-size: 100%;
      margin-right: ptrd(8px);
    }
  }
  &-list-item {
    padding-bottom: ptrd(30px);
    border-bottom: 1px solid #a8a8a8;
    & + .dlrActivity-list-item {
      padding-top: ptrd(30px);
    }
  }
}
</style>
